import type { RouterContextType } from "@/api/permissions/permissions.api";
import { AssessmentDetailsEditPage } from "@/components/features/WorkOrders/VisitDetail/AssessmentDetailsEditPage";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { createFileRoute, retainSearchParams } from "@tanstack/react-router";
import {
  leaveRecordTenant,
  recordTenantSearchSchema,
  syncRecordTenant,
} from "@/utils/recordTenantRoute";

export const Route = createFileRoute("/work-orders/$workOrderId/$visitId/assessment-details/")({
  component: AssessmentDetailsEdit,
  validateSearch: recordTenantSearchSchema.parse,
  search: { middlewares: [retainSearchParams(["tenant"])] },
  onEnter: syncRecordTenant,
  onStay: syncRecordTenant,
  onLeave: leaveRecordTenant,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function AssessmentDetailsEdit() {
  const { visitId, workOrderId } = Route.useParams();
  return <AssessmentDetailsEditPage visitId={visitId} workOrderId={workOrderId} />;
}
